import { Box, Typography } from '@mui/material';
import FileIcon from 'assets/icons/hashtags/file-icon.svg';
import ScheduleIcon from 'assets/icons/buttons/schedule-icon.svg';
import SelectionIcon from 'assets/icons/hashtags/selection-editor-icon.svg';
import SelectionOptionIcon from 'assets/icons/hashtags/selection-option-editor-icon.svg';
import { SubHashtagComponentProps } from './types';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';

const colorsMap = {
  [HashtagMentionTypeEnum.fileCabinetItem]: {
    color: '#47D06F',
    background: '#CCFFDB',
    icon: <FileIcon width={2} />,
  },
  [HashtagMentionTypeEnum.phaseItem]: {
    color: '#4D6EF5',
    background: '#E0EEFF',
    icon: <ScheduleIcon width={2} />,
  },
  [HashtagMentionTypeEnum.selection]: {
    color: '#EDC533',
    background: '#FFF9E5',
    icon: <SelectionIcon width={2} />,
  },
  [HashtagMentionTypeEnum.selectionOption]: {
    color: '#FF8368',
    background: '#FFE7E1',
    icon: <SelectionOptionIcon width={2} />,
  },
};

const styles = {
  wrapper: (background: string) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    background,
    padding: '0 4px',
    borderRadius: '8px',
    verticalAlign: 'middle',
  }),

  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 0,
    svg: {
      width: 14,
      height: 14,
      verticalAlign: 'middle',
    },
  },

  text: (color: string) => ({
    display: 'inline',
    verticalAlign: 'middle',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color,
  }),
};

export const Hashtag = (props: SubHashtagComponentProps) => {
  const { mention, decoratedText } = props;
  const { color, background, icon } = colorsMap[mention?.type] || {};

  return (
    <Box component="span" sx={styles.wrapper(background)}>
      <Box component="span" sx={styles.iconWrapper}>
        {icon}
      </Box>
      <Typography component="span" sx={styles.text(color)}>
        {decoratedText.replace(/^#/, '')}
      </Typography>
    </Box>
  );
};
